import type { ReportDraft, ReportJob } from './types';

const CSRF_COOKIE = 'pacebi_csrf';

function csrfToken(): string {
  const m = document.cookie.match(new RegExp('(?:^|; )' + CSRF_COOKIE + '=([^;]+)'));
  return m ? decodeURIComponent(m[1]) : '';
}

/** Submit a report to run in the background. Returns the queued job. */
export async function submitReportJob(draft: ReportDraft): Promise<ReportJob> {
  const res = await fetch('/api/report-jobs', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
    body: JSON.stringify(draft),
  });
  if (res.status === 503) throw new Error('Los reportes en segundo plano no están disponibles en este servidor.');
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${await res.text()}`);
  return (await res.json()) as ReportJob;
}

/** List the current user's report jobs (newest first). */
export async function listReportJobs(): Promise<ReportJob[]> {
  const res = await fetch('/api/report-jobs', { credentials: 'same-origin' });
  if (!res.ok) return [];
  const body = (await res.json()) as { jobs: ReportJob[] };
  return body.jobs ?? [];
}

export async function deleteReportJob(id: string): Promise<void> {
  const res = await fetch(`/api/report-jobs/${id}`, {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: { 'X-CSRF-Token': csrfToken() },
  });
  if (!res.ok && res.status !== 404) throw new Error(`HTTP ${res.status}`);
}

/** Trigger a browser download of a finished job's CSV. */
export function downloadReportJob(id: string): void {
  window.location.href = `/api/report-jobs/${id}/download`;
}
